import { httpClient } from "@coworker/http-client";
import { GroupedSalesLocations } from "@coworker/apprestructured/src/task-management/types/SalesLocation";

export async function getLocations(itemNo: string, type: string) {
  return httpClient.tasks.get<GroupedSalesLocations>("/v1/locations", {
    params: { itemNo, type },
  });
}
